export default __webpack_public_path__ + "0565d42abb39b08a03ede966a1cfeeaa.svg";